<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row class="steps">
          <el-col :span="24">
            <el-steps :active="active" align-center simple finish-status="success">
              <el-step v-for="item in steps" :key="item.title" :title="item.title" :description="item.description" />
            </el-steps>
          </el-col>
        </el-row>
        <div class="steps-content" v-if="active == 0">
          <el-row>
            <el-col>
              <el-form ref="companyForm" :model="formData" :rules="rules" label-width="180px">
                <!-- <el-form-item label="选择任务（已审核）" prop="name" id="list">
                  <el-select v-model="formData.name" placeholder="请选择对账清单">
                    <el-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-button style="margin-left:10px" type="text" @click="mxRedirect('/bill/create')">
                    如果没有对账清单，请先上传
                  </el-button>
                </el-form-item> -->
               <!--  <el-form-item label="服务类型" prop="desc" id="desc">
                  <el-select v-model="formData.category_id" filterable multiple placeholder="请选择服务类型">
                    <el-option
                      v-for="item in categoryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item> -->

                <el-form-item label="服务类型" prop="desc" id="desc" class="serve-wrapper">
                  <el-checkbox-group v-model="formData.category_id" size="small">
                    <el-checkbox
                      v-for="item in categoryList"
                      :label="item.name"
                      :key="item.id"
                      border>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>

                <el-form-item>
                  <!-- <el-button type="primary" size="medium" @click="openDialog">弹窗</el-button> -->
                  <el-button type="primary" size="medium" @click="formNext('companyForm')">下一步</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div class="steps-content" v-if="active == 1">
          <el-alert type="warning" :closable="false" id="el-alert">
            <template slot="title">
              <div>提示：</div>
              <div>1、导入数据需要跟模板格式一样方可导入</div>
              <div>2、点击进入导入，可选择导入文件或拖动导入文件进行导入</div>
            </template>
          </el-alert>
          <upload-excel
            @remove_file="handleRemoveFile"
            @return_url="handUploadFile"
            @handleSuccess="handleSuccess"
            :dir="'customer'"
            :selectfiles="'importExcel'"
            :postfiles="'submitImportExcel'"
            :ossfile="'ossExcelFile'"
            ref="uploadImg"
            :tableColumns="columns"
            :tableKeyMap="keyMap"
            :tableData="tableData"
            :max_width="1000"
            :max_height="1000" />
        </div>
      </div>
      <el-dialog
        title="系统提示"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
         @close="dialogVisible = false">
        <el-row>
          <el-col :span="8"><div v-show="isShow" class="status-title">成功：{{this.success}}个</div></el-col>
          <el-col :span="16"><div v-show="isShow" class="failstatus-title">失败：{{this.fail}}个</div></el-col>
        </el-row>
        <ApeTable ref="apeTable" style="font-size:12px;" :data="uploadFailList" :columns="columnsUpLoad" :loading="loadingStaus" :pagingData="pagingData" highlight-current-row></ApeTable>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false" size="medium">取 消</el-button> -->
          <el-button type="primary" size="medium" class="uploadCheck" @click="determine">确 定</el-button>
        </span>
      </el-dialog>
    </PageHeaderLayout>
  </div>
</template>
<script>
import UploadExcel from "@/components/UploadExcel";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'

export default {
  name: "Import",
  components: {
    UploadExcel,
    PageHeaderLayout,
    ApeTable,
    ModalDialog
  },
  data() {
    return {
      dialogVisible: false,
      loadingStaus: false,
      isShow: true,//控制弹框成功失败个数是否显示
      tableHeader: [],
      tableData: [],
      uploadFailList: [],//失败的数据列表
      success: 0,
      fail: 0,
      active: 0,
      categoryList: [],
      formData: {
        category_id: [],
      },
      rules: {
        category_id: [
          { required: true, message: '服务类型不能为空', trigger: 'blur'}
        ]
      },
      steps: [
        {
          title: '请选择服务类型',
          description: '',
          content: 'step1',
        },
        {
          title: '人才导入',
          description: '',
          content: 'step2',
        },
        {
          title: '完成',
          description: '',
          content: 'step3',
        },
      ],
      columnsUpLoad: [
        {
          title: "序号",
          value: "company_id",
        },
        {
          title: "姓名",
          value: "fullname",
        },
        {
          title: "证件类型",
          value: "id_type"
        },
        {
          title: "身份证号码",
          value: "id_number"
        },
        {
          title: "用户手机号码",
          value: "mobile"
        },
        {
          title: "失败原因",
          value: "error_msg"
        },
      ],
      columns: [
        {
          title: "姓名",
          value: "fullname",
        },
        {
          title: "证件类型",
          value: "id_type"
        },
        {
          title: "身份证号码",
          value: "id_number"
        },
        {
          title: "手机号码",
          value: "mobile"
        },
        {
          title: "编码[选填,20位以内]",
          value: "code",
        },
      ],
      keyMap: {
        'code': "code",
        'cardType': "id_type",
        'name': "fullname",
        'idCard': "id_number",
        'phone': "mobile",
      },
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      url: '',
      showButton: true
    };
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    }
  },
  methods: {
    openDialog() {
      this.showButton = true
      this.$confirm('确定要上传此表格的人员数据吗?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showConfirmButton: this.showButton,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.formSubmit()
        }).catch(() => {
        });
    },
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    async handUploadFile({ url, filename }) {
      console.log("->上传成功....", filename);
      this.url = url
      this.categoryList.find((value) => {
        this.formData.category_id.forEach((item, index) => {
          if(item == value.name) {
            item = value.id
            this.formData.category_id[index] = value.id
          }
        })
      });
      this.openDialog()
    },
    async formSubmit() {
      let info = {
        'file': this.url,
        'result': this.tableData,
        'category_id': this.formData.category_id
      }
      this.showButton = false
      let res = await this.$api.batchSaveCustomer(info)
      this.success = res.successNum
      this.fail = res.failedNum
      this.$nextTick(() => {
        this.uploadFailList=res.data
        if (res) {
          this.$message.success('数据上传成功')
          this.dialogVisible = true;
        }
      })
      this.showButton = true
    },
    //点击dialog小×的方法
    handleClose() {
      this.isShow = false;
      this.uploadFailList = [];
      this.dialogVisible = false;
      this.goBack()
    },
    //弹窗确定事件
    determine() {
      this.dialogVisible = false;
      this.isShow = false;
      this.uploadFailList = [];
      this.goBack()
    },
    handleSuccess({ results, header }) {
      this.tableHeader = header;
      console.log(results,"results")
      results.splice(0, 1)
      this.tableData = results;
    },
    //返回上一页
    goBack() {
      this.$router.push({ path: "/customer" });
    },
    // 初始化列表
    async init() {
      this.loadingStaus=true
      this.categoryList = await this.$api.getCustomerCategoryList()
      this.loadingStaus=false
    },
    //步骤
    formNext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.active++
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    next() {
      this.active++
      if(this.active == 2) {
        this.$message(
          {
            message: '恭喜你，操作完成',
            type: 'success'
          }
        )
      }
    },
    prev() {
      this.active--;
    },
  },
  mounted() {
    this.init()
  },
};
</script>
<style lang="stylus" scoped>
/deep/.el-checkbox-group label
  width: 180px
/deep/.el-checkbox-group label:first-child
  margin-left: 10px
/deep/.el-checkbox-group
  width: 660px
.uploadCheck
  margin-left: 10px
.status-title
  color: green
  font-size: 16px
.failstatus-title
  color: red
  font-size: 16px
.checktips
  display: flex
  flex-direction: row
.icon-tips
  color: #e6a23c
.tips-content
  color: #606266
  font-size: 14px
  padding-left: 36px
  padding-right: 12px
</style>
